// Constants for the order list table;

export const COLUMNS = [
  {
    label: 'Invoiced',
    field: 'invoiced',
    type: 'boolean'
  },
  {
    label: 'Office',
    field: 'agency.displayName',
  },
  {
    label: 'Order',
    field: 'campaign.displayName',
  },
  {
    label: 'Notes',
    field: 'campaign.campaignNotes',
  },
  {
    label: 'Free of Charge',
    field: 'campaign.foc'
  },
  {
    label: 'Finance Adjustments',
    field: '-'
  },
  {
    label: 'Type',
    field: 'campaignType',
  },
  {
    label: 'Suburb',
    field: 'campaign.property.suburb',
  },
  {
    label: 'Start Date',
    field: 'campaign.startDate',
    type: 'date',
    dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ssXXX',
    dateOutputFormat: 'dd MMM yyyy',
  },
  {
    label: 'End Date',
    field: 'campaign.endDate',
  },
  {
    label: 'Booked Date',
    field: 'campaign.createdAt',
    type: 'date',
    dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ssXXX',
    dateOutputFormat: 'dd MMM yyyy',
  },
];

export const PAGINATION_OPTIONS = {
  enabled: true,
  mode: 'pages',
  perPageDropdownEnabled: false,
}

export const SORT_OPTIONS = {
  enabled: false
}


export const NOTES_COLUMNS = [
  {
    label: 'Note',
    field: 'note'
  },
  {
    label: 'Created By',
    field: 'createdBy',
  },
  {
    label: 'Created At',
    field: 'createdAt',
    type: 'date',
    dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ssXXX',
    dateOutputFormat: 'dd MMM yyyy h:mm aa',
  },
];